import { render, staticRenderFns } from "./ApplicationReviewModalHeader.vue?vue&type=template&id=9954041c&"
import script from "./ApplicationReviewModalHeader.vue?vue&type=script&lang=ts&"
export * from "./ApplicationReviewModalHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports